import BaseModel from '../core/BaseModel'
//import CategoriesModel from './CategoriesModel'
export default class MaintenanceProcessModel extends BaseModel {
    constructor() {
        super({
                name: "maintenance_process",
                tableName: 'core_maintenance_process'
            },
            {
                id: {
                    name: 'id',
                    type: "String",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },
                fied_detail: {
                    refs: 'process_status ',
                    display: false
                },
            },)
    }

}